const recommendationProducts = () => {
  // Load product recommendations in section
  const loadProductRecommendationsIntoSection = () => {
    const productRecommendations = document.querySelector('#related-products');

    if (productRecommendations === null) {
      return;
    }

    const baseUrl = productRecommendations.dataset.baseUrl;

    // Read product id from data attribute
    const productId = productRecommendations.dataset.productId;

    // Read limit from data attribute
    const limit = productRecommendations.dataset.limit;

    // Build request URL
    let pageTemplate = 'products';

    const requestUrl = `${baseUrl}?section_id=related-products&product_id=${productId}&limit=${limit}`;

    // Create request and submit it using AJAX
    const request = new XMLHttpRequest();
    request.open('GET', requestUrl);

    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        const container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendations.parentElement.innerHTML = container.querySelector('.js-products').innerHTML;
      }
    };

    request.send();
  };

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'related-products') {
      loadProductRecommendationsIntoSection();
    }
  });

  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();
};

recommendationProducts();
